/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query SmsCountFailedQuery($customerId: ID!, $endDate: DateTime!, $startDate: DateTime!) {
    SmsCountFailed(customerId: $customerId, endDate: $endDate, startDate: $startDate) {
      count,
      _totalCount,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
